import React from "react";
import { Linkedin, Instagram, Mail } from "lucide-react";

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={props.className || "w-4.5 h-4.5"} {...props}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.572-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.99c-.002 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413" />
  </svg>
);

export default function SocialLinks() {
  const socials = [
    { icon: Linkedin, href: "https://www.linkedin.com/company/studlyf/", name: "LinkedIn" },
    { icon: Instagram, href: "https://www.instagram.com/studlyf.in?igsh=M28wNmExcG11cW5z", name: "Instagram" },
    { icon: WhatsAppIcon, href: "https://whatsapp.com/channel/0029VbCHsjAHVvTRqLfOau24", name: "WhatsApp" },
    { icon: Mail, href: "mailto:studlyf21@gmail.com", name: "Email" },
  ];

  return (
    <div className="flex flex-wrap gap-2.5">
      {socials.map((item, idx) => {
        const Icon = item.icon;
        return (
          <a
            key={idx}
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full border border-gray-200/80 bg-white/60 text-gray-500 hover:text-[#7C3AED] hover:border-[#7C3AED]/25 hover:bg-[#F4F1FF] flex items-center justify-center transition-all duration-300 hover:scale-110 active:scale-95 shadow-xs"
            title={item.name}
            data-testid={`footer-social-${item.name.toLowerCase()}`}
          >
            <Icon className="w-4.5 h-4.5" />
          </a>
        );
      })}
    </div>
  );
}
